import { createContext, useContext, useReducer } from 'react'
import { reducer, initialState } from './reducer'
import { useComponentIsMountedRef } from 'Hooks'

AclContext = createContext()

export AclDataProvider = ({ children }) ->

  isMounted = useComponentIsMountedRef()
  [state, dispatch] = useReducer(reducer, initialState)

  protectedDispatch = (args...) ->
    return unless isMounted.current
    dispatch(args...)

  <AclContext.Provider value={[state, protectedDispatch]}>
    { children }
  </AclContext.Provider>

export useAclData = ->
  useContext(AclContext)
